import React from 'react'
import {SocialIcon} from 'react-social-icons'
import { motion} from 'framer-motion'

export default function Header() {
  return (
    <header className='sticky top-0 p-5 flex items-start justify-between  xl:max-w-[1090px] max-w-7 mx-auto xl:items-center z-50'>
        
        <motion.div 
        initial={{
            x:-500,
            opacity: 0,
            scale:0.5
        }}
        animate={{
            x:0,
            opacity:1,
            scale:1,
        }}
        transition={{
            duration:1.5,
        }}
        
        className="flex flex-row items-center ">
            <SocialIcon url="https://facebook.com/nqabasikeyi"
             fgColor="grey"
             bgColor="transparent"
             />
             <SocialIcon url="https://api.whatsapp.com/send/?phone=%2B263712579746&text=I%27m+interested+in+working+with+you&type=phone_number&app_absent=0"
             fgColor="grey"
             bgColor="transparent"
             />
             <SocialIcon url="https://www.linkedin.com/in/nqaba-j-sikeyi-827665265/"
             fgColor="grey"
             bgColor="transparent"
             />
             <SocialIcon url="https://twitter.com/nqaba_sikeyi"
             fgColor="grey"
             bgColor="transparent"
             />
             
        </motion.div>
        

        <a href="#contactme">
        <motion.div 
        initial={{
            x:500,
            opacity:0,
            scale:0.5
        }}
        animate={{
            x:0,
            opacity:1,
            scale:1
        }}
        transition={{duration:1.5}}
        className='flex flex-row items-center text-gray-300 cursor-pointer '>
            <SocialIcon 
             className="cursor-pointer"
             network="email"
             fgColor="grey"
             bgColor="transparent"
             />
             <div className='hidden uppercase-hidden md:inline-flex text-sm text-gray-400'>
                Get In Touch
            </div>
    </motion.div>
        </a>
        
    </header>
  )
}